export default __webpack_public_path__ + "static/media/gallery_11.49a05cfa.jpg";